export const EXTENSION_NAME = "codeBlock";
